module.exports = __webpack_public_path__ + "static/img/banner4.2a2f929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner4.png
// module id = RHBR
// module chunks = 0